<template>
  <transition name="welcome-fade">
    <div
      v-if="visible"
      class="welcome"
      @touchstart="onTouchStart"
      @touchmove="onTouchMove"
      @touchend="onTouchEnd"
      @click="onClick"
    >
      <img v-if="imageUrl" :src="imageUrl" class="bg" draggable="false" />

      <!-- 底部提示 -->
      <div class="bottom-hint">
        <span class="hint-text">向上滑动显示更多</span>
        <span class="hint-arrow">︿</span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Welcome',
  props: {
    imageUrl: { type: String, default: '' }
  },
  data() {
    return {
      visible: true,
      startY: 0,
      // 触发关闭需要向上滑动的最小距离（像素）
      threshold: 50
    }
  },
  methods: {
    dismiss() {
      if (!this.visible) return
      this.visible = false
      // 0.3s 渐隐动画结束后通知父组件销毁
      setTimeout(() => {
        this.$emit('dismissed')
      }, 300)
    },
    onTouchStart(e) {
      this.startY = e.touches[0].clientY
    },
    onTouchMove(e) {
      // 计算实时滑动距离（向上为正）
      const delta = this.startY - e.touches[0].clientY
      if (delta > this.threshold) {
        // 触发关闭
        this.dismiss()
      }
    },
    onTouchEnd() {
      this.startY = 0
    },
    onClick() {
      // 点击屏幕兜底：让用户随时可以进入首页
      this.dismiss()
    }
  }
}
</script>

<style scoped>
.welcome {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: #000;
  overflow: hidden;
  user-select: none;
  -webkit-user-select: none;
  -webkit-tap-highlight-color: transparent;
  /* 允许纵向滑动触发；禁止其他浏览器默认行为（页面整体滚动、文本选择等） */
  touch-action: pan-y;
}
.bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* 防止 iOS 长按弹菜单 */
  -webkit-touch-callout: none;
  pointer-events: none;
}
.bottom-hint {
  position: absolute;
  bottom: 28px;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  z-index: 2;
  /* 兜底：背景图偏浅时也能看清 */
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
}
.hint-text {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);
  letter-spacing: 2px;
}
.hint-arrow {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.85);
  animation: hint-bounce 1.6s ease-in-out infinite;
}
@keyframes hint-bounce {
  0%, 100% { transform: translateY(0); opacity: 0.6; }
  50% { transform: translateY(-6px); opacity: 1; }
}
.welcome-fade-enter-active,
.welcome-fade-leave-active {
  transition: opacity 0.3s ease;
}
.welcome-fade-enter,
.welcome-fade-leave-to {
  opacity: 0;
}
</style>
